import Components from "../components";

class SiteForm extends Components.Base {
  initialize() {
    this.showHelp();
    this.addHeaderButton = this.$el.find("#add_header");
    this.addResponseHeaderButton = this.$el.find("#add_response_header");
  }

  bind() {
    this.on("change", "select#site_match_type", () => this.showHelp());
    this.on("click", "#add_header", (e) => this.addHeader(e));
    this.on("click", "#headers a.delete", (e) => this.removeHeader(e));
    this.on("click", "#add_response_header", (e) => this.addResponseHeader(e));
    this.on("click", "#response_headers a.delete", (e) =>
      this.removeResponseHeader(e),
    );
  }

  showHelp() {
    const value = this.$el.find("select#site_match_type").val();
    $(".match-type-help").hide();
    $(`[data-match-type="${value}"]`).show();
    $("[data-match-type-not]").show();
    $(`[data-match-type-not="${value}"]`).hide();
  }

  addHeader(event) {
    event.preventDefault();
    const headerGroup = $(event.target).parents("#headers");
    headerGroup.append(
      this.$el
        .find("#header_template")
        .html()
        .replace(/0/g, Date.now())
        .replace(/resource_name/g, "site"),
    );
    if (
      headerGroup.find(".input-group").length >=
      Number.parseInt(this.addHeaderButton.data("max-headers"), 10)
    ) {
      this.addHeaderButton.css("display", "none").attr("disabled", true);
    }
  }

  removeHeader(event) {
    event.preventDefault();
    $(event.target).parents(".input-group").remove();
    this.addHeaderButton.css("display", "").attr("disabled", false);
  }

  addResponseHeader(event) {
    event.preventDefault();
    const headerGroup = $(event.target).parents("#response_headers");
    headerGroup.append(
      this.$el
        .find("#response_header_template")
        .html()
        .replace(/0/g, Date.now())
        .replace(/resource_name/g, "site"),
    );
    if (
      headerGroup.find(".input-group").length >=
      Number.parseInt(this.addResponseHeaderButton.data("max-headers"), 10)
    ) {
      this.addResponseHeaderButton
        .css("display", "none")
        .attr("disabled", true);
    }
  }

  removeResponseHeader(event) {
    event.preventDefault();
    $(event.target).parents(".input-group").remove();
    this.addResponseHeaderButton.css("display", "").attr("disabled", false);
  }
}

Components.collection.register({ selector: ".c-site-form", klass: SiteForm });
